import { render, staticRenderFns } from "./PensionUnitSelectionEditButton.vue?vue&type=template&id=610aa2e4&scoped=true&"
import script from "./PensionUnitSelectionEditButton.vue?vue&type=script&lang=ts&"
export * from "./PensionUnitSelectionEditButton.vue?vue&type=script&lang=ts&"
import style0 from "./PensionUnitSelectionEditButton.vue?vue&type=style&index=0&id=610aa2e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610aa2e4",
  null
  
)

export default component.exports